import { DETAIL_VIEWS } from '@experiment-management-shared/constants/experimentConstants';
import useQueryParamsForExperiments from '@experiment-details/hooks/useQueryParamsForExperiments';

export const getOutliers = isVisible => ({
  isVisible,
  percentile: isVisible ? 0 : 5
});

export const QUERY_PARAM_KEYS = {
  SMOOTHING: 'smoothing',
  VIEW: 'view',
  OUTLIERS: 'showOutliers',
  SEARCH: 'search',
  X_AXIS: 'xAxis',
  COMPARE_X_AXIS: 'compareXAxis',
  TRANSFORM_Y: 'transformY'
};

const useMetricChartQueryParams = ({
  location,
  experimentKey,
  currentTemplate,
  searchText
}) => {
  const { pathname } = location;

  const {
    outliers: { isVisible: showOutliers } = {},
    smoothing,
    x_axis: xAxis,
    panels: { compareXAxis } = {},
    transformY
  } = currentTemplate || {};

  useQueryParamsForExperiments(
    {
      'experiment-tab': DETAIL_VIEWS.PANELS,
      search: searchText,
      smoothing,
      showOutliers,
      xAxis,
      compareXAxis,
      transformY
    },
    [
      searchText,
      smoothing,
      xAxis,
      compareXAxis,
      showOutliers,
      transformY,
      pathname
    ],
    experimentKey
  );
};

export default useMetricChartQueryParams;
